const { BookingCommandConnector } = require('./BookingCommandConnector');
const { BusinessUserServiceConnector } = require('./BusinessUserServiceConnector');
const { CorporationServiceConnector } = require('./CorporationServiceConnector');
const { EmployeeServiceConnector } = require('./EmployeeServiceConnector');
const { BusinessReportingServiceConnector } = require('./BusinessReportingServiceConnector');
const { FleetAccountServiceConnector } = require('./FleetAccountServiceConnector');
const { OfferServiceConnector } = require('./OfferServiceConnector');
const { SuggestionServiceConnector } = require('./SuggestionServiceConnector');
const { BookingHistoryServiceConnector } = require('./BookingHistoryServiceConnector');
const { EmployeeGroupServiceConnector } = require('./EmployeeGroupServiceConnector');
const { TravelRestrictionServiceConnector } = require('./TravelRestrictionServiceConnector');
const { TravelRestrictionAssociationConnector } = require('./TravelRestrictionAssociationConnector');
const { CorporationGuestServiceConnector } = require('./CorporationGuestServiceConnector');
const { FareEstimatorConnector } = require('./FareEstimatorConnector');
const { PaymentMethodServiceConnector } = require('./PaymentMethodServiceConnector');
const { PaxCoreConnector } = require('./PaxCoreConnector');
const { FavouriteAddressConnector } = require('./FavouriteAddressConnector');
const { DriverStatesCommandConnector } = require('./DriverStatesCommandConnector');

module.exports = {
  BookingCommandConnector,
  BusinessReportingServiceConnector,
  BusinessUserServiceConnector,
  CorporationServiceConnector,
  EmployeeServiceConnector,
  FleetAccountServiceConnector,
  BookingHistoryServiceConnector,
  SuggestionServiceConnector,
  OfferServiceConnector,
  EmployeeGroupServiceConnector,
  TravelRestrictionServiceConnector,
  TravelRestrictionAssociationConnector,
  CorporationGuestServiceConnector,
  FareEstimatorConnector,
  PaymentMethodServiceConnector,
  PaxCoreConnector,
  FavouriteAddressConnector,
  DriverStatesCommandConnector,
};
